import React, { useEffect } from 'react';
import {
  Route,
  Routes,
  redirect,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import { userRole } from './GetRole.utils';

const ProtectedRoute = ({ Component }) => {
  const nav = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const role = userRole;
    if (role !== 'bdTeam') {
      if (location.pathname !== '/pendingApprovals') {
      }
      if (location.pathname === '/') {
        nav('/');
      }
    } else {
      nav('/');
    }
  }, [Component]);

  return (
    <div>
      <Component />
    </div>
  );
};

export default ProtectedRoute;
